<template>
  <div class="history-curve">
    <div class="cure-top">
      <div class="two-font-wrapper" @click="back">
          <div class="icon-font">&#xe612;</div>
          返回
        </div>
      <div class="cure-top-title">环境温湿度感器历史曲线</div>
      <div class="cure-top-select">
        <div style="margin-right: 1vw">
          <DropDownInput type="0" :items="sensorValue" :content="historyInfo.nodeId" @sendValue="sendValue" @sendInfo="showInfo"></DropDownInput>
        </div>
        <div style="display: flex">
          <div class="input-contain">
            <div class="input-title">X：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input  v-model="historyInfo.siteX"/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">Y：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input v-model="historyInfo.siteY"/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">Z：</div>
            <div class="input-wrapper" style="width: 5vw">
              <input v-model="historyInfo.siteZ"/>
            </div>
          </div>
        </div>
        <div class="input-date-wrapper">
          <el-date-picker
            v-model="value"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="query button" @click="buttonSearch">查询</div>
      </div>
    </div>
    <div v-if="historyInfo.nodeId" class="history-info">设备ID：{{historyInfo.nodeId}}<span v-if="stack">，采集位置：{{stack}}{{maintainStage}}</span></div>
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <div class="chart-wrapper" v-show="!loading" id="myChart6" v-if="rows.length > 0"></div>
    <div class="none-data" v-if="!loading && rows.length<1">暂无数据</div>
  </div>
</template>

<script>
import DropDownInput from '../../../../components/DropDownInput.vue'
import {queryRtNodeMonitInfo, queryNodeAvgHistoryInfo, queryMaintainPlanBySite} from '../../../../api/maintain'
import {getDay} from '../../../../tools/methods'
let echarts = require('echarts')
let myChart6
export default {
  name: 'HistoryAll',
  components: { DropDownInput },
  data () {
    return {
      percentage: '',
      rows: [],
      loading: false,
      moduleType: '03',
      nodeType: '03',
      sensorValue: [],
      siteLocation: '',
      value: '',
      historyInfo: {
        endTime: '',
        nodeId: '',
        siteX: '',
        siteY: '',
        siteZ: '',
        startTime: ''
      },
      name_T: '温度/(℃)',
      name_P: '湿度/(%)',
      maintainStage: '',
      stack: ''
    }
  },
  watch: {
    value: function () {
      console.log(this.value)
      this.historyInfo.startTime = this.value !== null ? this.value[0] : ''
      this.historyInfo.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  created () {
    this.handleSearch()
    if (this.$route.query.nodeId) {
      this.stack = this.$route.query.stack
      this.historyInfo.startTime = getDay(-6)
      this.historyInfo.endTime = getDay(0)
      this.historyInfo.nodeId = this.$route.query.nodeId
      this.value = [getDay(-6), getDay(0)]
      this.buttonSearch()
      this.maintainStage = this.$route.query.maintainStage
    }
  },
  methods: {
    buttonSearch: function () {
      this.loading = true
      queryNodeAvgHistoryInfo(this.historyInfo).then(res => {
        console.log(res)
        if (res.code === 500) {
          this.loading = false
          this.$message({
            message: res.message,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        } else {
          console.log(res)
          this.rows = res.data
          this.loading = false
          let that = this
          if (this.rows.length > 0) {
            setTimeout(function () {
              that.getCharts()
              myChart6.on('legendselectchanged', function (obj) {
                console.log(obj)
                if (obj.selected.温度高 === false && obj.selected.温度低 === false && obj.selected.温度均 === false) {
                  that.name_T = ''
                  that.getChart6()
                }
                if (obj.selected.温度高 === true || obj.selected.温度低 === true || obj.selected.温度均 === true) {
                  that.name_T = '温度/(℃)'
                  that.name_P = '湿度/(%)'
                  that.getChart6()
                }
                if (obj.selected.湿度高 === false && obj.selected.湿度低 === false && obj.selected.湿度均 === false) {
                  that.name_P = ''
                  that.getChart6()
                }
                if (obj.selected.湿度高 === true || obj.selected.湿度低 === true || obj.selected.湿度均 === true) {
                  that.name_P = '湿度/(%)'
                  that.getChart6()
                }
              })
            }, 100)
          }
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    sendValue: function (value) {
      console.log(value)
      this.handleSearch(value)
    },
    showInfo: function (data) {
      this.historyInfo.nodeId = data.nodeId
      console.log(data)
    },
    handleSearch: function (value) {
      let body = {
        moduleType: this.moduleType,
        nodeType: this.nodeType,
        nodeId: value
      }
      queryRtNodeMonitInfo(body).then(res => {
        console.log(res)
        this.sensorValue = res.data.rows
      }).catch(err => {
        console.log(err)
      })
    },
    getCharts: function () {
      this.getChart6(0)
      window.onresize = function () {
        myChart6.resize()
      }
    },
    getChart6: function () {
      console.log(this.rows)
      let date = []
      let avgMoistureValue = []
      let avgTempValue = []
      let maxMoistureValue = []
      let maxTempValue = []
      let minMoistureValue = []
      let minTempValue = []
      if (this.rows.length < 25) {
        this.percentage = 100
      } else {
        this.percentage = 2500 / this.rows.length
      }
      this.rows.map(item => {
        date.push(item.date_time)
        avgMoistureValue.push(item.avg_moisture_val)
        avgTempValue.push(item.avg_temp_val)
        maxMoistureValue.push(item.max_moisture_val)
        maxTempValue.push(item.max_temp_val)
        minMoistureValue.push(item.min_moisture_val)
        minTempValue.push(item.min_temp_val)
      })
      myChart6 = echarts.init(document.getElementById('myChart6'))
      myChart6.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {type: 'dashed'}
          }
        },
        textStyle: {color: '#ffffff'},
        legend: {
          y: 'top',
          right: '5%',
          itemGap: 50,
          textStyle: {color: '#01c5f1'},
          data: [
            {name: '温度低'},
            {name: '温度高'},
            {name: '温度均'},
            {name: '湿度低'},
            {name: '湿度高'},
            {name: '湿度均'}
          ]
        },
        grid: {
          top: '15%',
          right: '0.5%',
          left: '0.5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          splitLine: {show: false},
          axisTick: false,
          axisLine: {
            lineStyle: {color: '#32b16c'}
          },
          axisLabel: {
            textStyle: {
              fontSize: 8
            },
            interval: 0,
            rotate: 45
          },
          data: date
        },
        yAxis: [
          {
            type: 'value',
            scale: 'true',
            axisTick: false,
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['#2a2f57']
              }
            },
            axisLine: {
              lineStyle: {color: '#32b16c'}
            },
            splitNumber: '5',
            name: this.name_T
          },
          {
            type: 'value',
            scale: 'true',
            axisTick: false,
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['#2a2f57']
              }
            },
            axisLine: {
              lineStyle: {color: '#32b16c'}
            },
            splitNumber: '5',
            name: this.name_P
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            show: false,
            start: 0,
            end: this.percentage,
            handleSize: 8
          },
          {
            type: 'inside',
            start: 0,
            end: this.percentage
          },
          {
            type: 'slider',
            show: false,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 12,
            height: '70%',
            handleSize: 8,
            showDataShadow: false,
            left: '93%'
          }
        ],
        series: [
          {
            name: '温度低',
            type: 'line',
            symbol: 'triangle',
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#01c5f1'
                },
                color: '#01c5f1'
              }
            },
            data: minTempValue
          },
          {
            name: '温度高',
            type: 'line',
            symbol: 'triangle',
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#a84200'
                },
                color: '#a84200'
              }
            },
            data: maxTempValue
          },
          {
            name: '温度均',
            type: 'line',
            symbol: 'triangle',
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#32b16c'
                },
                color: '#32b16c'
              }
            },
            data: avgTempValue
          },
          {
            name: '湿度低',
            type: 'line',
            symbol: 'circle',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#01c5f1'
                },
                color: '#01c5f1'
              }
            },
            data: minMoistureValue
          },
          {
            name: '湿度高',
            type: 'line',
            symbol: 'circle',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#a84200'
                },
                color: '#a84200'
              }
            },
            data: maxMoistureValue
          },
          {
            name: '湿度均',
            type: 'line',
            symbol: 'circle',
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: '#32b16c'
                },
                color: '#32b16c'
              }
            },
            data: avgMoistureValue
          }
        ]
      })
    },
    back: function () {
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped>
  @import "HistoryCurve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warehouse/historyCurve/WareHistoryAll.vue